// extracted by mini-css-extract-plugin
export default {"checkingContainer":"CheckingContainer_checkingContainer__yfJeq","text":"CheckingContainer_text__BvIKq"};